export function imgUploadAstrict(file,that) {
  var fileSuffix = file.name.substring(file.name.lastIndexOf('.') + 1)
  let allowSuffix = ["bmp", "jpg", "png", "tif", "gif", "pcx", "tga", "exif", "fpx", "svg", "psd", "cdr", "pcd", "dxf", "ufo", "eps", "ai", "raw", "WMF", "webp"];
  if (allowSuffix.indexOf(fileSuffix) >= 0) {
    return true;
  }
  that.$message({
    message: '上传文件只能是' + allowSuffix.toString() + '格式!',
    type: 'warning'
  });
  return false
}
